import React from "react";

const TokenBrand = ({ brand }) => {
  return (
    <div className="col-md-3 divider-right dr-1">
      <div className="company-icon">
        <img src={brand} alt="" />
      </div>
    </div>
  );
};

export default TokenBrand;
//"/img/company-icon.png"
